'use strict';

module.exports = require('./browser/algorithms.json');



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/algos.js
// module id = 1063
// module chunks = 44